<template>
    <content-view max-width="1280">
        <v-row class="mt-8" justify="center" align="center">
            <v-col cols="auto" class="pt-0 pb-0 headline text-start">탈퇴회원 목록</v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="pt-0 pb-0">
                <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch"><v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터</v-btn>
            </v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mx-auto">
                <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                <v-card-text class="py-0">
                    <v-row class="mt-4" align="center">
                        <v-col cols="12" sm="4" class="py-0">
                            <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" placeholder=" " hide-details @input="filter.searchValue = null;" />
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                            <v-text-field v-model="filter.searchValue" label="검색어" placeholder=" " hide-details :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true);" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="page = 1; search(true);"><v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색</v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

        <v-data-table :headers="membersHeaders" :items="members" disable-sort disable-pagination hide-default-footer class="elevation-1 mt-4">
            <template v-slot:[`header.username`]="{ header }">
                {{ header.text }}
                <v-btn icon x-small>
                    <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'username')" @click="sortOptions(`username`, false)">mdi-arrow-up-bold-outline</v-icon>
                    <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'username')"  @click="sortOptions(`username`, true)">mdi-arrow-up-bold</v-icon>
                    <v-icon v-if="(filter.sortDesc && filter.sortBy == 'username')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                </v-btn>
            </template>
            <template v-slot:[`header.name`]="{ header }">
                {{ header.text }}
                <v-btn icon x-small>
                    <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'name')" @click="sortOptions(`name`, false)">mdi-arrow-up-bold-outline</v-icon>
                    <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'name')"  @click="sortOptions(`name`, true)">mdi-arrow-up-bold</v-icon>
                    <v-icon v-if="(filter.sortDesc && filter.sortBy == 'name')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                </v-btn>
            </template>
            <template v-slot:[`header.createdAt`]="{ header }">
                {{ header.text }}
                <v-btn icon x-small>
                    <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'createdAt')" @click="sortOptions(`createdAt`, false)">mdi-arrow-up-bold-outline</v-icon>
                    <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'createdAt')"  @click="sortOptions(`createdAt`, true)">mdi-arrow-up-bold</v-icon>
                    <v-icon v-if="(filter.sortDesc && filter.sortBy == 'createdAt')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                </v-btn>
            </template>
            <template v-slot:[`header.withdrawnAt`]="{ header }">
                {{ header.text }}
                <v-btn icon x-small>
                    <v-icon v-if="(filter.sortBy == null || filter.sortBy !== 'withdrawnAt')" @click="sortOptions(`withdrawnAt`, false)">mdi-arrow-up-bold-outline</v-icon>
                    <v-icon v-if="(filter.sortDesc == false && filter.sortBy == 'withdrawnAt')"  @click="sortOptions(`withdrawnAt`, true)">mdi-arrow-up-bold</v-icon>
                    <v-icon v-if="(filter.sortDesc && filter.sortBy == 'withdrawnAt')" @click="sortOptions(null, null)">mdi-arrow-down-bold</v-icon>
                </v-btn>
            </template>
            <template v-slot:item.createdAt="{ item }">
                <span v-if="item.createdAt">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.withdrawnAt="{ item }">
                <span v-if="item.withdrawnAt">{{ $dayjs(item.withdrawnAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.phone="{ item }">
                {{ (item.phone || "").phoneNumberFormat() }}
            </template>
            <template v-slot:item.isWarning="{ item }">
                <v-row justify="center" align="center">
                    <v-col cols="auto" class="pa-0">
                        <v-switch v-model="item.isWarning" color="red lighten-1" hide-details dens class="mt-0"></v-switch>
                    </v-col>
                </v-row>
            </template>
        </v-data-table>
        
        <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4 mb-12 mx-4" @input="search"></v-pagination>
    </content-view>
</template>

<script>
import api from "@/api";
import ContentView from "@/pages/console/templates/ConsoleContent.vue";

export default {
    components: {
        ContentView
    },
    data() {
        return {
            showSearch: true,

            page: 1,
            pageCount: 0,
            limit: 10,
            filter: {
                isWithdrawal: true,
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
                sortBy: null,
                sortDesc: null
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "이름", value: "name" },
                { text: "아이디", value: "username" },
                { text: "연락처", value: "phone" },
                { text: "이메일", value: "email" },
            ],

            members: [],
            membersHeaders: [
                {
                    text: '아이디',
                    align: 'center',
                    width: 200,
                    value: 'username',
                },
                {
                    text: '이름',
                    align: 'center',
                    value: 'name',
                },
                {
                    text: '연락처',
                    align: 'center',
                    width: 200,
                    value: 'phone'
                },
                {
                    text: '이메일',
                    align: 'center',
                    width: 200,
                    value: 'email'
                },
                {
                    text: '가입일자',
                    align: 'center',
                    width: 200,
                    value: 'createdAt'
                },
                {
                    text: '탈퇴일자',
                    align: 'center',
                    width: 200,
                    value: 'withdrawnAt'
                },
            ],

            warningsItems: [
                { text: "전체", value: undefined },
                { text: "주의회원", value: true },
                { text: "미주의회원", value: false }
            ]

        };
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            this.search();
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, members } = await api.console.members.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.members = members;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        async sortOptions(sortBy, sortDesc) {
            this.filter.sortBy = sortBy;
            this.filter.sortDesc = sortDesc;
            await this.init();
        }
    }
}
</script>
